import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    leading-[1.5]
    hover:cursor-pointer
    label-sm
    inline-flex
    items-center
  `,
  {
    variants: {
      color: {
        default: 'default-text',
        disabled: 'disabled-text',
        emphasis: 'emphasis-text',
        header: 'header-text',
        link: 'link-text',
        muted: 'muted-text',
        danger: 'text-danger',
        brand: 'brand',
        priority: 'priority',
        highlight: 'text-green-100',
        yellow: 'text-yellow-200',
        moss: 'text-moss-200',
        red: 'text-red-200',
        orange: 'text-orange-200',
        green: 'text-green-200',
        white: 'text-neutral-0',
      },
      disabled: {
        true: `
          disabled-text
          hover:cursor-not-allowed
        `,
      },
      variant: {
        primary: `
          underline
          hover:text-brand
        `,
        secondary: `
          border-b-2
          border-green-50
          border-dotted
        `,
        noUnderline: `
          no-underline
          hover:text-brand
        `,
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
)
